import { AxiosResponse } from 'axios';
import { API_LDAP_CONFIGURATION_ROUTE } from 'config/api-consts';
import { httpConfig } from 'config/http';
import { API_BASE_URL } from 'core/config';
import { url } from 'core/helpers/string';
import { Repository } from 'core/repositories/Repository';
import kebabCase from 'lodash/kebabCase';
import { LdapConfiguration } from 'models/LdapConfiguration';
import nameof from 'ts-nameof.macro';

export class LdapConfigurationRepository extends Repository {
    constructor() {
        super(httpConfig);
        this.setBaseURL(url(API_BASE_URL, API_LDAP_CONFIGURATION_ROUTE));
    }
    public get = (): Promise<LdapConfiguration> => {
        return this.http
            .post<LdapConfiguration>(kebabCase(nameof(this.get)))
            .then((response: AxiosResponse<LdapConfiguration>) =>
                LdapConfiguration.clone<LdapConfiguration>(response.data),
            );
    };
    public update = (ldapConfiguration: LdapConfiguration): Promise<LdapConfiguration> => {
        return this.http
            .post<LdapConfiguration>(kebabCase(nameof(this.update)), ldapConfiguration)
            .then((response: AxiosResponse<LdapConfiguration>) =>
                LdapConfiguration.clone<LdapConfiguration>(response.data),
            );
    };

}


export const ldapConfigurationRepository: LdapConfiguration = new LdapConfigurationRepository();
